import { useCallback } from "react";
import { useState, ComponentPropsWithoutRef } from "react";
import { SelectedItem } from "..";
import MovedMessageTag from "../components/moved-message-tag";
import getMovedMessage from "./utils/getMovedMessage";

export default function useMovedToTag() {
  const [movedToProps, setMovedToProps] =
    useState<
      Pick<
        ComponentPropsWithoutRef<typeof MovedMessageTag>,
        "message" | "success"
      >
    >();

  const onMoveEnd = useCallback(
    ({
      selected,
      originFolder,
      targetFolder,
      success,
    }: {
      selected: SelectedItem[];
      originFolder?: { name: string };
      targetFolder?: { name: string };
      success: boolean;
    }) => {
      setMovedToProps({
        message: getMovedMessage({
          selected,
          originFolder,
          targetFolder,
          success,
        }),
        success,
      });
    },
    [],
  );

  return {
    MovedToTag: (
      <MovedMessageTag
        onHide={() =>
          setMovedToProps({
            message: undefined,
          })
        }
        {...movedToProps}
      />
    ),
    onMoveEnd,
  };
}
